/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserOutputDto { 
    name?: string | null;
    middleName?: string | null;
    surName?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    username?: string | null;
    creationTime?: string;
    isPhoneNumberConfirmed?: boolean;
    isEmailConfirmed?: boolean;
}

